import * as Cesium from "cesium";

import type { SolarAnchor } from "@/lib/solar/calculateSolarPosition";
import type { BasemapLightingOptions } from "./types";
import type { Season } from "@/stores/solarSimulationStore";

export const MODE_LUMIERE_DEBUG_PAR_DEFAUT = "sun" as const;
export const INTENSITE_LUMIERE_PAR_DEFAUT = 2.0;
export const COULEUR_LUMIERE_PAR_DEFAUT = Cesium.Color.WHITE;
export const OMBRES_TERRAIN_PAR_DEFAUT = Cesium.ShadowMode.RECEIVE_ONLY;
export const OMBRES_BASEMAP_PAR_DEFAUT = Cesium.ShadowMode.RECEIVE_ONLY;
export const FACTEUR_IBL_BASEMAP_LIT_PAR_DEFAUT = 3.0;
export const FACTEUR_IBL_BASEMAP_DEBUG_PAR_DEFAUT = 1.0;
export const INTENSITE_LUMIERE_BASEMAP_LIT_PAR_DEFAUT = 4.0;
export const MULTIPLICATEUR_LUMIERE_ARCHITECTE_PAR_DEFAUT = 2.0;
export const MULTIPLICATEUR_LUMIERE_PAYSAGISTE_PAR_DEFAUT = 4.0;
export const PLANCHER_LUMINEUX_BASEMAP_LIT_PAR_DEFAUT = 1.0;
export const PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_ACTIF_PAR_DEFAUT = true;
export const PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_MIN_PAR_DEFAUT = 0.03;
export const PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_MAX_PAR_DEFAUT = 1.0;
export const FACTEUR_IBL_BASEMAP_NUIT_PAR_DEFAUT = 0;
export const INTENSITE_LUMIERE_BASEMAP_NUIT_PAR_DEFAUT = 0;

export function creerOptionsEclairageBasemapParDefaut(
  hour: number,
  season: Season,
  anchor?: SolarAnchor,
): BasemapLightingOptions {
  return {
    imageBasedLightingFactor: {
      diffuse: FACTEUR_IBL_BASEMAP_LIT_PAR_DEFAUT,
      specular: 0.0,
    },
    lightColorIntensity: INTENSITE_LUMIERE_BASEMAP_LIT_PAR_DEFAUT,
    plancherLumineuxLit: PLANCHER_LUMINEUX_BASEMAP_LIT_PAR_DEFAUT,
    plancherLumineuxDynamique: {
      actif: PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_ACTIF_PAR_DEFAUT,
      minimum: PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_MIN_PAR_DEFAUT,
      maximum: PLANCHER_LUMINEUX_BASEMAP_DYNAMIQUE_MAX_PAR_DEFAUT,
      hour,
      season,
    },
    attenuationNocturne: {
      actif: true,
      iblMinimum: FACTEUR_IBL_BASEMAP_NUIT_PAR_DEFAUT,
      lightColorMinimum: INTENSITE_LUMIERE_BASEMAP_NUIT_PAR_DEFAUT,
      hour,
      season,
    },
    solaire: {
      hour,
      season,
      anchor,
    },
  };
}
